export default "__VITE_ASSET__DyVbRdoB__"